import { useState } from "react";
import { useAuth } from "@/contexts/AuthContext";
import { toast } from "sonner";
import { Link, Outlet, useLocation, useNavigate } from "react-router-dom";
import { Sidebar } from "./Sidebar";
import { Toaster } from "@/components/ui/sonner";
import { SocialIcons } from "./SocialIcons";
import { PageTour } from "@/components/ui/page-tour";

export function Layout() {
  const location = useLocation();
  const navigate = useNavigate();
  const { signOut } = useAuth();
  const [signingOut, setSigningOut] = useState(false);
  const handleSignOut = async () => {
    setSigningOut(true);
    try {
      const { error } = await signOut();
      if (error) throw error;
      navigate("/auth/login", { replace: true });
    } catch {
      toast.error("Could not sign out. Please try again.");
    } finally {
      setSigningOut(false);
    }
  };
  const announcementMessage = "Your report is ready. Turn your priority actions into improvements with Ruby.";
  
  console.log("Layout rendering, current path:", location.pathname);
  console.log("SocialIcons component is being used in Layout");
  
  return (
    <div className="flex h-screen bg-og01-bg relative">
      {/* OG01 Page Background Glow */}
      <div className="og01-page-glow" />
      
      <Sidebar />
      
      <div className="flex flex-1 flex-col overflow-hidden relative z-10">
        <div className="flex h-16 items-center justify-between px-6 border-b border-og01-card bg-og01-bg/80 backdrop-blur-sm">
          {/* Dashboard guidance */}
          <div className="flex flex-1 min-w-0 items-center gap-4">
            <p className="text-sm text-og01-text-secondary">{announcementMessage}</p>
            <Link
              to="/ruby-aissist"
              className="shrink-0 rounded-lg bg-og01-purple px-4 py-2 text-sm font-semibold text-white transition-opacity hover:opacity-90 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-og01-purple"
            >
              Open Ruby
            </Link>
          </div>
          
          {/* Social icons */}
          <div className="ml-4 flex shrink-0 items-center gap-3">
            <SocialIcons />
            <button type="button" onClick={handleSignOut} disabled={signingOut}
              className="rounded-lg border border-og01-card px-3 py-2 text-sm font-semibold text-og01-text-secondary hover:text-white disabled:opacity-50">
              {signingOut ? "Signing out…" : "Sign out"}
            </button>
          </div>
        </div>
        
        <main className="flex-1 overflow-y-auto pb-6">
          <Outlet />
        </main>
      </div>
      
      <Toaster position="top-right" />
      <PageTour />
    </div>
  );
}
